import loadable from "@loadable/component";
import { fetchRegionalPrices } from "../features/regionalPrices/regionalPricesSlice";
import { fetchExchangeRates } from "../features/exchangeRates/exchangeRatesSlice";

const PerformanceOld = loadable(() => import("./PerformanceOld.page"));

const loadData = (store) => {
  const { localization: { data } } = store.getState();
  const actions = [fetchRegionalPrices(data), fetchExchangeRates()];
  return Promise.all(actions.map((action) => store.dispatch(action)));
};

export default { component: PerformanceOld, loadData };
